module.exports = require("ember-inflector");